import { render, staticRenderFns } from "./CommonMoreBgColor.vue?vue&type=template&id=7e970286&scoped=true"
import script from "./CommonMoreBgColor.vue?vue&type=script&lang=js"
export * from "./CommonMoreBgColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e970286",
  null
  
)

export default component.exports